import React from 'react';
import { SectionWrapper, CTAButton } from './Shared';
import { ShieldCheck } from 'lucide-react';
export const Pricing = () => {
  return <SectionWrapper id="pricing" className="relative" data-id="element-115">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-prime-gold/10 via-prime-black to-prime-black pointer-events-none" data-id="element-116" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-117">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-118">
          Recupera Tu Mando Hoy
        </h2>

        <p className="text-lg text-prime-textMuted mb-12 leading-relaxed" data-id="element-119">
          Podríamos cobrar fácilmente{' '}
          <span className="text-white line-through" data-id="element-120">$197</span> por este sistema
          (menos de lo que cuesta una consulta con un especialista). Pero
          nuestra misión es ayudar a 10,000 hombres a recuperar su mando este
          año. Por eso, si actúas hoy, puedes obtener el sistema completo por
          una fracción de su valor real.
        </p>

        <div className="bg-prime-card border-2 border-prime-gold rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,83,0.15)] relative" data-id="element-121">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-prime-red text-white font-bold px-6 py-1 rounded-full text-sm tracking-wider uppercase whitespace-nowrap" data-id="element-122">
            Oferta de Lanzamiento
          </div>

          <p className="text-prime-textMuted uppercase tracking-widest text-sm font-bold mb-4" data-id="element-123">
            Tu Precio Hoy:
          </p>

          <div className="flex justify-center items-end gap-4 mb-6" data-id="element-124">
            <span className="text-3xl text-prime-textMuted line-through mb-2" data-id="element-125">
              $97
            </span>
            <span className="text-7xl md:text-8xl font-serif font-bold text-prime-gold leading-none" data-id="element-126">
              $6,39
            </span>
          </div>

          <p className="text-prime-text bg-prime-black inline-block px-4 py-2 rounded-full border border-white/10 mb-10" data-id="element-127">
            Ahorras más de $90...{' '}
            <span className="italic text-prime-textMuted" data-id="element-128">
              por menos de lo que cuesta un café.
            </span>
          </p>

          <CTAButton data-id="element-129">SÍ, QUIERO ACCESO INMEDIATO POR $6,39</CTAButton>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-prime-textMuted" data-id="element-130">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-131" />
            <span data-id="element-132">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};